<script setup>
import {
    computed,
    ref,
    getCurrentInstance,
    onMounted,
    watch
} from 'vue'
import { useRoute } from 'vue-router'
import emitter from '../utils/emitter'
import { notifyDialog } from '../composables/useDialogNotice'
import DriverCard from '../components/driverCard.vue'
import KonopabankForm from '../components/konopabankForm.vue'
import PersonaForm from '../components/personaForm.vue'
import RedeemcodeForm from '../components/redeemcodeForm.vue'
import prestigeForm from '../components/prestigeForm.vue'
import NavRailItem from '../components/NavRailItem.vue'
import {
    DriverStore
} from '../pinia/Driver.js'

const {
    proxy
} = getCurrentInstance()

const Driver = DriverStore()
const route = useRoute()

var dialog = ref(false)
var dialogswitch = ref(false)
var model = ref(1)

onMounted(() => {
    if (route.path === '/redeemcode') {
        dialog.value = true
        model.value = '3'
        setTimeout(() => {
            if (route.query.code) {
                emitter.emit('setRedeemCode', route.query.code)
            }
        }, 100)
        const code = route.query.code
        if (code) {
            emitter.emit('setRedeemCode', code)
        }
    }
})

watch(() => route.path, (newPath) => {
    if (newPath === '/redeemcode') {
        dialog.value = true
        model.value = '3'
        const code = route.query.code
        if (code) {
            emitter.emit('setRedeemCode', code)
        }
    }
})
const modelswitch = ref()

const avatar = ref(null)
const name = ref("")
const avatars = Array.from({ length: 73 }, (_, index) => index).filter((index) => index !== 26)
const avatarUrl = (index) => `https://cdn.nightriderz.world/images/website/icon-persona/${index}.webp`
const FREE_DRIVER_LIMIT = 3
const PREMIUM_DRIVER_LIMIT = 5
const isPremium = computed(() => Driver.user?.premium == '1' || Driver.user?.premium == 1 || Driver.persona?.premium == '1' || Driver.persona?.premium == 1)
const driverCount = computed(() => 1 + (Array.isArray(Driver.others) ? Driver.others.length : 0))
const maxDrivers = computed(() => isPremium.value ? PREMIUM_DRIVER_LIMIT : FREE_DRIVER_LIMIT)
const atDriverLimit = computed(() => driverCount.value >= maxDrivers.value)

function selectAvatar(index) {
    avatar.value = index
}

async function save() {
    if (atDriverLimit.value) return

    if (avatar.value === null || avatar.value === '' || !name.value) {
        notifyDialog({ type: 'error', message: 'Choose a name and avatar.' })
        return
    }

    const res = await proxy.$api({
        serviceName: "account",
        methodName: "create_persona",
        parameters: [name.value, avatar.value]
    })

    if (res == "error") {
        notifyDialog({ type: 'error', message: 'This name is unavailable.' })
        return
    }

    Driver.setEasharpptr_p(res)
    GetUserInfo()
    dialogswitch.value = false
    modelswitch.value = 1
    name.value = ""
    avatar.value = null
    notifyDialog({ type: 'success', message: 'Driver created.' })
}

async function GetUserInfo() {
    const res = await proxy.$api({
        serviceName: "session",
        methodName: "GetUserInfo"
    })

    Driver.setPersona(res.persona)
    Driver.setUser(res.user)
    Driver.setCrew(res.crew)
    Driver.setCurrentCrew(res.crew.current)
    Driver.setOthers(res.others)
    Driver.setLogged(true)
}
</script>

<template><NavRailItem label="My driver" @click="dialog = true">
    <template #icon>
        <img class="nav-persona-avatar" :src="'https://cdn.nightriderz.world/images/website/icon-persona/' + Driver.persona.iconIndex + '.webp'" alt="" width="28" height="28" decoding="async" />
    </template>
</NavRailItem>

<NavRailItem icon="account-switch" label="Switch driver" @click="dialogswitch = true" />

<v-dialog v-model="dialogswitch" :width="520" scrollable transition="dialog-bottom-transition">
    <v-card>
        <v-toolbar dark color="primary">
            <v-icon class="mr-3">mdi-account-switch</v-icon>
            <v-toolbar-title>My Drivers</v-toolbar-title>
            <v-spacer></v-spacer>
            <template v-slot:extension>
                <v-tabs v-model="modelswitch" centered>
                <v-tab value="1"> SWITCH DRIVER </v-tab>
                <v-tab value="2"> CREATE DRIVER </v-tab>
            </v-tabs>
        </template>
        </v-toolbar>

        <v-card-text>
            <v-window v-model="modelswitch">
                <v-window-item value="1">
                    <div class="driver-cards-list">
                        <DriverCard :data="Driver.persona" :changebis="true" />
                        <DriverCard v-for="driver in Driver.others" :data="driver" :change="true" @closeDialog="dialogswitch = false" />
                    </div>
                </v-window-item>
                <v-window-item value="2">
                    <div class="settings-tab-page">
                        <div class="settings-tab-header">
                            <div class="header-icon"><v-icon size="28">mdi-account-plus</v-icon></div>
                            <div class="header-content">
                                <h3 class="page-title">Create Driver</h3>
                                <p class="page-subtitle">Choose a name and avatar for your new driver</p>
                            </div>
                        </div>
                        <v-alert v-if="atDriverLimit" color="info" icon="mdi-information" class="mb-4">
                            You have reached the maximum of {{ maxDrivers }} drivers{{ isPremium ? '.' : '. Premium accounts can create up to 5.' }}
                        </v-alert>
                        <div v-if="!atDriverLimit" class="section-list">
                            <div class="section-row">
                                <div class="section-body">
                                    <div class="setting-item">
                                        <div class="setting-info full-width">
                                            <div class="setting-label">
                                                <v-icon size="20" class="mr-2">mdi-account</v-icon>
                                                Driver Name
                                            </div>
                                            <div class="setting-description">Choose a unique name (3-14 characters, alphanumeric)</div>
                                            <v-text-field v-model="name" placeholder="Enter driver name" variant="outlined" density="comfortable" hide-details class="setting-input" />
                                        </div>
                                    </div>
                                    <v-divider class="my-4" />
                                    <div class="setting-item">
                                        <div class="setting-info full-width">
                                            <div class="setting-label">
                                                <v-icon size="20" class="mr-2">mdi-face-man</v-icon>
                                                Avatar
                                            </div>
                                            <div class="setting-description">Select an avatar for your driver</div>
                                            <div v-if="avatar !== null" class="avatar-preview">
                                                <img class="avatar-preview-img" :src="avatarUrl(avatar)" :alt="'Avatar ' + avatar" width="72" height="72">
                                                <div class="avatar-preview-meta">
                                                    <span class="avatar-preview-title">Selected</span>
                                                    <span class="avatar-preview-id">Avatar {{ avatar }}</span>
                                                </div>
                                            </div>
                                            <div class="avatar-grid-create" role="listbox" aria-label="Driver avatars">
                                                <button v-for="index in avatars" :key="index" type="button" class="avatar-item" :class="{ 'is-selected': avatar === index }" :aria-selected="avatar === index" :title="'Avatar ' + index" @click="selectAvatar(index)">
                                                    <img :src="avatarUrl(index)" :alt="'Avatar ' + index" width="56" height="56" loading="lazy">
                                                    <span v-if="avatar === index" class="avatar-check"><v-icon size="14">mdi-check</v-icon></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <v-btn class="create-btn save-btn" variant="elevated" color="primary" size="large" block :disabled="atDriverLimit" @click="save">
                                        <v-icon class="mr-2">mdi-account-plus</v-icon>
                                        Create Driver
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-window-item>
            </v-window>
        </v-card-text>
    </v-card>
</v-dialog>

<v-dialog transition="dialog-bottom-transition" :width="520" v-model="dialog" scrollable>
    <v-card>
        <v-toolbar dark color="primary">
            <v-avatar @click="dialog = true" :image="'https://cdn.nightriderz.world/images/website/icon-persona/' + Driver.persona.iconIndex + '.webp'"></v-avatar>
            <v-toolbar-title>{{Driver.persona.name}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogswitch = true">
                <v-icon>mdi-account-switch</v-icon>
                <v-tooltip activator="parent" location="bottom" text="Switch driver" />
            </v-btn>
            <template v-slot:extension>
                <v-tabs v-model="model" centered>
                    <v-tab value="1"> Driver </v-tab>
                    <v-tab value="2"> Prestige </v-tab>
                    <v-tab value="3"> Redeem code </v-tab>
                    <v-tab value="4"> Konopa Bank </v-tab>
                </v-tabs>
            </template>
        </v-toolbar>

        <v-card-text>
            <v-window v-model="model">
                <v-window-item value="1">
                    <PersonaForm />
                </v-window-item>
                <v-window-item value="2">
                    <prestigeForm />
                </v-window-item>
                <v-window-item value="3">
                    <RedeemcodeForm :initial-code="route.query.code || ''" />
                </v-window-item>
                <v-window-item value="4">
                    <KonopabankForm />
                </v-window-item>
            </v-window>
        </v-card-text>

    </v-card>
</v-dialog></template>

<style scoped>
:deep(.v-list-item__prepend) {
  font-size: 30px !important;
  margin-top: 10px;
}
.nav-persona-avatar {
  display:block;
  width:28px;
  height:28px;
  border-radius:50%;
  object-fit:cover}
#menu {
  margin-bottom:10px!important}
.downloadbtn {
  display:flex;
  justify-content:center;
  margin:10px 0}
button {
  margin:initial!important}
.avatar-preview {
  display:flex;
  align-items:center;
  gap:14px;
  margin:12px 0 14px;
  padding:12px;
  border-radius:10px;
  background:var(--glass);
  border:1px solid var(--line)}
.avatar-preview-img {
  width:72px;
  height:72px;
  border-radius:12px;
  object-fit:cover;
  border:2px solid rgb(var(--v-theme-primary));
  box-shadow:0 0 0 3px rgba(var(--v-theme-primary),.18)}
.avatar-preview-meta {
  display:flex;
  flex-direction:column;
  gap:2px;
  min-width:0}
.avatar-preview-title {
  font-size:12px;
  letter-spacing:.04em;
  text-transform:uppercase;
  color:var(--faint)}
.avatar-preview-id {
  font-size:15px;
  font-weight:600;
  color:var(--ink)}
.avatar-grid-create {
  display:grid;
  grid-template-columns:repeat(auto-fill,minmax(56px,1fr));
  gap:8px;
  max-height:280px;
  overflow-y:auto;
  overflow-x:hidden;
  padding:10px;
  margin-bottom:16px;
  background:var(--glass);
  border-radius:10px;
  border:1px solid var(--line-strong)}
.avatar-grid-create::-webkit-scrollbar {
  width:6px}
.avatar-grid-create::-webkit-scrollbar-track {
  background:var(--glass);
  border-radius:3px}
.avatar-grid-create::-webkit-scrollbar-thumb {
  background:rgba(var(--v-theme-primary),.3);
  border-radius:3px}
.avatar-grid-create::-webkit-scrollbar-thumb:hover {
  background:rgba(var(--v-theme-primary),.5)}
.avatar-item {
  position:relative;
  display:block;
  padding:0;
  margin:0;
  border:none;
  background:transparent;
  cursor:pointer;
  border-radius:10px;
  line-height:0}
.avatar-item img {
  width:100%;
  aspect-ratio:1;
  height:auto;
  border-radius:10px;
  object-fit:cover;
  border:2px solid rgba(255,255,255,.1);
  transition:border-color .2s ease,transform .2s ease,box-shadow .2s ease}
.avatar-item:hover img {
  border-color:rgba(var(--v-theme-primary),.55);
  transform:translateY(-1px)}
.avatar-item.is-selected img {
  border-color:rgb(var(--v-theme-primary));
  box-shadow:0 0 0 2px rgba(var(--v-theme-primary),.35)}
.avatar-check {
  position:absolute;
  right:4px;
  bottom:4px;
  width:18px;
  height:18px;
  border-radius:50%;
  display:inline-flex;
  align-items:center;
  justify-content:center;
  background:rgb(var(--v-theme-primary));
  color:#fff;
  box-shadow:0 1px 4px #00000059}
.create-btn {
  margin-top:0!important;
  font-weight:600;
  letter-spacing:.5px}
.create-btn .v-icon {
  opacity:1!important}
.driver-cards-list {
  display:flex;
  flex-direction:column;
  gap:8px}
.v-list-item-title {
  margin:10px 0!important}
</style>
